import { Observable } from "rxjs";
import {
    BRAND_PREFERENCES_UPDATE,
    BRAND_PREFERENCES_UPDATE_COMPLETE,
    BRAND_SETTINGS_UPDATE,
    BRAND_SECRETS_UPDATE,
    BRAND_SECRETS_UPDATE_COMPLETE,
} from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateBrandPreferencesEpic = (action$, store) => {
    return action$
        .ofType(BRAND_PREFERENCES_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((preferences) => {
            return ajax({
                method: "POST",
                body: preferences,
                url: `${siteConfig.api}/brand/preferences`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving preferences") })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_PREFERENCES_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_PREFERENCES_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Preferences Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = error?.xhr?.response?.message || formatMessage("Error saving preferences");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit preferences");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_PREFERENCES_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const updateBrandSettingsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_SETTINGS_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((settings) => {
            return ajax({
                method: "POST",
                body: settings,
                url: `${siteConfig.api}/brand/info/update-base`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving settings") })),
                            {
                                payload: new Error("Error saving settings"),
                                error: true,
                                type: BRAND_PREFERENCES_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_PREFERENCES_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Settings Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving settings");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit settings");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_PREFERENCES_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};

export const updateBrandSecretsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_SECRETS_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap(({ secrets, brandId }) => {
            return ajax({
                method: "POST",
                body: secrets,
                url: `${siteConfig.api}/brand/${brandId}/secrets/update`,
            })
                .map(({ status }) => {
                    if (status >= 200 && status < 300) {
                        return { result: [], error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving secrets") })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_SECRETS_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_SECRETS_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Secrets Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving secrets");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit secrets");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_SECRETS_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
